// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Input, Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons/lib";
import { formItemBlockLayout } from "../../../../utils/Constant";
import { requestWorkflowNews } from "../../../../state/news/NewsEffects";
import {
  NewsRefusedFormProps,
  NewsWorkflowStatus
} from "../../../types/NewsTypes";

export const NewsRefusedPublicationButton: React.FunctionComponent<NewsRefusedFormProps> = (
  props: NewsRefusedFormProps
) => {
  const { t } = useTranslation();
  const { newsId } = props;
  const [visible, setVisible] = useState<boolean>(false);

  const handleSubmit = (values: any) => {
    requestWorkflowNews({
      id: newsId,
      dto: {
        status: NewsWorkflowStatus.REFUSED,
        readingNotes: values.readingNotes
      }
    });
  };

  return (
    <>
      <Button
        type="default"
        className="btn-warning m-2"
        onClick={() => setVisible(true)}
      >
        <WarningOutlined />
        {t("edit_news.refuse.text")}
      </Button>
      <Modal
        title={t("edit_news.refuse.modal.title")}
        okText={t("global.confirm")}
        okButtonProps={{
          form: "news_refused_publication_form",
          htmlType: "submit"
        }}
        onCancel={() => setVisible(false)}
        cancelText={t("global.cancel")}
        visible={visible}
        centered
      >
        <Form
          id="news_refused_publication_form"
          {...formItemBlockLayout}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="readingNotes"
            label={
              <span>{t("edit_news.refuse.modal.reading_notes.title")}</span>
            }
            rules={[
              {
                required: true,
                message: t("global.empty_error_field"),
                whitespace: true
              }
            ]}
          >
            <Input.TextArea
              id="readingNotes"
              placeholder={t(
                "edit_news.refuse.modal.reading_notes.placeholder"
              )}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
